import React from "react";
import { useIntl } from "react-intl";
import { useOutletContext } from "react-router";
import { PageWrapper } from "components/Containers";
import { TimelinePage } from "components/Timeline";

/**
 * Mission Role Timeline
 */
const MissionRoleTimeline = () => {
  const intl = useIntl();
  const { selectedRole } = useOutletContext();

  return (
    <PageWrapper>
      <TimelinePage
        resourceId={selectedRole?.id}
        pageTitle={intl.formatMessage({ id: "Meta.Missions.Role.Timeline.Title" })}
        subtitleId="Missions.Roles.Timeline.Title"
        keyName="missionRoleEvents"
        resourceKeyName="missionRoleId"
      />
    </PageWrapper>
  );
};

export default MissionRoleTimeline;
